// Plain text a session wrote, split into the little structure it carries: paragraphs at blank lines, « 1. »/« 1) »
// lines as an ordered list, « - »/« * » lines as a bullet list. No Markdown, no HTML: the blocks hold text only.

export type TextBlock =
  | { kind: 'p'; text: string }
  | { kind: 'ol'; start: number; items: string[] }
  | { kind: 'ul'; items: string[] };

const ORDERED = /^\s{0,3}(\d{1,4})[.)]\s+(.*)$/;
const BULLET = /^\s{0,3}[-*]\s+(.*)$/;

/** Paragraphs at blank lines, « 1. »/« 1) » lines as an ordered list, « - »/« * » lines as a bullet list.
 *  An indented line under an item continues it. */
export function parseBlocks(text: string): TextBlock[] {
  const blocks: TextBlock[] = [];
  let current: TextBlock | null = null;
  const close = () => { if (current) blocks.push(current); current = null; };
  for (const raw of text.replace(/\r\n?/g, '\n').split('\n')) {
    const line = raw.trimEnd();
    if (!line.trim()) { close(); continue; }
    const ordered = ORDERED.exec(line);
    const bullet = ordered ? null : BULLET.exec(line);
    if (ordered) {
      if (current?.kind !== 'ol') { close(); current = { kind: 'ol', start: Number(ordered[1]), items: [] }; }
      current.items.push(ordered[2]);
    } else if (bullet) {
      if (current?.kind !== 'ul') { close(); current = { kind: 'ul', items: [] }; }
      current.items.push(bullet[1]);
    } else if (current && current.kind !== 'p' && /^\s/.test(line)) {
      const items = current.items;
      items[items.length - 1] += `\n${line.trim()}`;
    } else if (current?.kind === 'p') {
      current.text += `\n${line}`;
    } else {
      close();
      current = { kind: 'p', text: line };
    }
  }
  close();
  return blocks;
}
